<template>
  <div>
    <h4 class="title is-4">
        <span>Результаты</span>
    </h4>
    <h6 class="subtitle is-6">{{ survey.title }}</h6>
    
    <template v-if="filters.length > 0">
        <hr>

        <h4 class="title is-4">Фильтрация ответов</h4>

        <div
            class="columns"
            v-for="(filter, index) in filters"
            :key="index + 1">
            <div class="column has-text-right">
                <p>{{ $_.truncate(filter.title) }}</p>
            </div>
            <div class="column">
                <b-select
                    expanded
                    v-model="appliedFilters[filter.uuid]">
                    <option :value="null">Любой ответ</option>
                    <option
                        :value="option"
                        v-for="option in filter.options"
                        :key="option.uuid"
                    >
                        {{ option.title }}
                    </option>
                </b-select>
            </div>
        </div>
    </template>

    <question-summary
      v-for="question in questions"
      :key="question.uuid"
      :question="question"
      :answers="questionAnswers[question.uuid]"
    />
  </div>
</template>

<script>
import toasts from "../../mixins/toasts";
import QuestionSummary from "../../survey/QuestionSummary";

export default Vue.extend({
  props: {
    survey: {
      type: Object,
      required: true
    }
  },
  mixins: [toasts],
  components: { QuestionSummary },
  data() {
    return {
      updateInterval: 30000,
      appliedFilters: {},
      questions: [],
      answers: []
    };
  },
  created() {
    axios
      .get(`/api/surveys/${this.survey.id}/questions`)
      .then(response => {
        this.questions = response.data;

        setInterval(() => {
          this.loadAnswers();
        }, this.updateInterval);
        this.loadAnswers().then(() => {
          this.toast(
            "info",
            "Результаты обновляются без перезагрузки страницы"
          );
        })
        .catch(error => {
          this.toast("error", "@unexpected", error);
        });
      })
      .catch(error => {
        this.toast("error", "@unexpected", error);
      });
  },
  methods: {
    loadAnswers() {
      return axios
        .get(`/api/surveys/${this.survey.id}/answers`)
        .then(response => {
          this.answers = _.map(response.data, "answers");
        });
    }
  },
  computed: {
    filters() {
      return _.filter(this.questions, {
        type: "radio",
        filter: true
      });
    },
    filteredForms() {
      let forms = [];

      let filteredForms = {};

      for (let uuid in this.appliedFilters) {
        let filter = this.appliedFilters[uuid];
        if (!filter) {
          continue;
        }

        filteredForms[uuid] = [];

        // Iterate over each individual survey "filled form".
        for (let form of this.answers) {
          // Iterate over each answer in each form.
          for (let answer of form) {
            // If at least one answer fits filter criteria,
            // include form with this answer.
            if (uuid == answer.question && filter.uuid == answer.answer) {
              //   forms.push(form);
              filteredForms[uuid].push(form);
              break;
            }
          }
        }
      }

      // If none of the filters applied, just return original
      // answers, otherwise return filtered forms.
      if (Object.keys(filteredForms).length == 0) {
        return this.answers;
      } else {
        let result;

        // Calculate intersection between all filtered forms.
        for (let uuid in filteredForms) {
          let forms = filteredForms[uuid];
          if (!result) {
            result = forms;
          } else {
            result = _.intersection(result, forms);
          }
        }

        return result;
      }
    },
    questionAnswers() {
      let answers = {};

      for (let question of this.questions) {
        answers[question.uuid] = _.flatten(
          _.map(this.filteredForms, answers => {
            return _.filter(answers, {
              question: question.uuid
            });
          })
        );
      }

      return answers;
    }
  }
});
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/views/surveys/Results.vue